module.exports = __webpack_public_path__ + "static/media/tipen.694ce96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipen.png
// module id = 334
// module chunks = 0